import Service from 'additiv-services';

type ErrorCallback = (error: unknown) => void;

const handlerRequestCanceling = (callback?: ErrorCallback) => (error: Error): void => {
    if (typeof callback === 'function') {
        if (!Service.isCanceled(error)) {
            callback(error);
        }
    } else {
        console.error('callback should be function');
    }
};

export default handlerRequestCanceling;
